import { useState, useEffect } from "react"
import { CameraAltOutlined } from "@mui/icons-material"
import { IconButton, Alert } from "@mui/material"
import ClearIcon from '@mui/icons-material/Clear';

import { ObservationImages } from "../../constants"
import "./style.css"

const CustomizedImageInput = (props) => {
    const { questionId, id, filename, onChange, onDelete } = props
    const [image, setImage] = useState()
    const [isSuccess, setIsSuccess] = useState(false)
    const [statusMsg, setStatusMsg] = useState("")
    const [alertMessage, setAlertMessage] = useState(false)

    const handleFileUpload = (e) => {
        e.preventDefault()
        if (!e.target.files[0]) {
            return
        }

        const status = ObservationImages.addImage({
            id,
            questionId,
            image: e.target.files[0]
        })

        if (status.isSucess) {
            setImage(e.target.files[0])
            onChange(id, e.target.files[0].name)
        }
        else {
            e.target.value = ""
            setImage()
            setAlertMessage(true)
            setStatusMsg(status.message)
            setIsSuccess(false)
        }
        setTimeout(() => {
            setAlertMessage(false);
        }, 3000);
    }

    const updateBackground = () => {
        if (image) {
            return URL.createObjectURL(image)
        }
        else {
            return ""
        }
    }

    const handleCloseAlertMessage = () => {
        setAlertMessage(false);
    }

    useEffect(() => {
        return () => {
            /* if it is used as image picker */
            if (onChange) {
                setImage()
                ObservationImages.removeImage({
                    id,
                    questionId,
                })
            }
        }
    }, [])

    useEffect(() => {
        if (filename === "") {
            setImage()
        }
        else {
            const currentObservationImage = ObservationImages.getImageOfObservation(questionId)
            const currentImage = currentObservationImage.filter(i => i.id === id)
            if (currentImage.length > 0) {
                setImage(currentImage[0].image)
            }
        }
    }, [filename])

    return (
        <>
            <div
                className="image-input-container"
                style={{
                    backgroundImage: !image ? "url('')" : `url(${updateBackground()})`,
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div className="image-input">
                    <IconButton aria-label="upload picture" component="label" style={{ visibility: image !== undefined ? "hidden" : "visible" }}>
                        <CameraAltOutlined />
                        <input accept="image/*" capture='environment' hidden type="file" onChange={handleFileUpload} />
                    </IconButton>
                    <p style={{ visibility: image !== undefined ? "hidden" : "visible" }}>Cliquez ici pour prendre une photo</p>
                </div>
                {image && onDelete ? <div className="image-delete-btn" onClick={() => onDelete(id)}><ClearIcon /></div> : null}
            </div>

            {alertMessage ? <div className="alert-message">
                {isSuccess && (<Alert style={{ width: '100%' }} onClose={handleCloseAlertMessage}>{statusMsg}</Alert>)}
                {!isSuccess && (<Alert severity="error" style={{ width: '100%' }} onClose={handleCloseAlertMessage}>{statusMsg}</Alert>)}
            </div> : null}
        </>
    )
}
export default CustomizedImageInput;